import { useEffect, useRef, useState } from 'react';

const VideoAudioWaveform: React.FC<any> = ({src,status,video,position}) =>{


  const videoRef = useRef(null);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const videoData = videoRef.current;



    // When the video is ready, seek to the startTime
    const onLoaded = () => {
      videoData.currentTime = position.start;
    };

    videoData.addEventListener('loadedmetadata', onLoaded);

    // Listen to time updates to stop at endTime
    const onTimeUpdate = () => {
      if (videoData.currentTime >= position.end) {
        videoData.pause();
      }
    };

    videoData.addEventListener('timeupdate', onTimeUpdate);

    return () => {
      videoData.removeEventListener('loadedmetadata', onLoaded);
      videoData.removeEventListener('timeupdate', onTimeUpdate);
    };
  }, [video,position]);
  useEffect(() => {
    togglePlay(status)
  }, [status,]);

  const togglePlay = (status) => {
    if(!isReady)return;
    const videodata = videoRef.current;
    if (status) {
      let isPlaying = video.currentTime > 0 && !video.paused && !video.ended 
    && video.readyState > video.HAVE_CURRENT_DATA;
      if(isPlaying) return;
        videodata.play();
    } else {
      videodata.pause();
    }
  };

  return (
    <div>
      {/* Hidden video element for audio source */}
      <video
        ref={videoRef}
        src={video && video.video.size > 0 ? URL.createObjectURL(video.video) : ""}
        style={{ display: 'none' }}
        crossOrigin="anonymous"
        onCanPlay={() => setIsReady(true)}
      />


      {/* Simple controls */}
    {/*   
    <button onClick={togglePlay} disabled={!isReady}>
        {isReady ? 'audio wave implementation in progess' : 'Loading...'}
      </button> 
      */}
    </div>
  );
}

export default VideoAudioWaveform;